import { api } from '@/lib/api'
import type { Account, AccountCreate } from '@/types/account'

export async function listAccounts(): Promise<Account[]> {
  const { data } = await api.get<Account[]>('/accounts/')
  return data
}

export async function createAccount(body: AccountCreate): Promise<Account> {
  const { data } = await api.post<Account>('/accounts/', body)
  return data
}
